// src/firebase/config.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

// Your web app's Firebase configuration (bucket uses the new *.firebasestorage.app format)
const firebaseConfig = {
  apiKey: "AIzaSyCURF_hbGVdey2N0MfFBn9opRhY7hGzwzs",
  authDomain: "family-reunion-app-7b99e.firebaseapp.com",
  projectId: "family-reunion-app-7b99e",
  storageBucket: "family-reunion-app-7b99e.firebasestorage.app", // ✅ correct for buckets created after Oct 30, 2024
  messagingSenderId: "218768576293",
  appId: "1:218768576293:web:5b24f98b9c285102a494cc",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Services
const auth = getAuth(app);
const db = getFirestore(app);

// Either rely on the config bucket (recommended)...
const storage = getStorage(app);

// ...or force the bucket explicitly (also fine):
// const storage = getStorage(app, "gs://family-reunion-app-7b99e.firebasestorage.app");

const functions = getFunctions(app);

// Providers
const googleProvider = new GoogleAuthProvider();

export { auth, db, storage, functions, googleProvider };
